import React from "react";

const SearchWrapper = ({ children }) => {
  return (
    <div className="flex flex-wrap justify-between items-center gap-3 px-4 py-3 border-b border-line bg-gradient-to-b from-subtle to-white/80">
      {children}
    </div>
  );
};

export default SearchWrapper;
